import React, { useState } from "react";
import api, { formatErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter, DialogTrigger,
} from "@/components/ui/dialog";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

export default function ChangePasswordDialog({ trigger }) {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password !== form.confirm) {
      toast.error("كلمتا المرور غير متطابقتين");
      return;
    }
    setSaving(true);
    try {
      const { data } = await api.post("/auth/change-password", {
        current_password: form.current_password,
        new_password: form.new_password,
      });
      if (data.token) localStorage.setItem("token", data.token);
      toast.success("تم تغيير كلمة المرور بنجاح");
      setOpen(false);
      setForm({ current_password: "", new_password: "", confirm: "" });
    } catch (e) { toast.error(formatErr(e)); }
    finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        {trigger || (
          <Button variant="outline" size="sm" className="rounded-xl border-[#e6e2d8]" data-testid="change-password-trigger">
            <KeyRound className="w-4 h-4 me-2" /> تغيير كلمة المرور
          </Button>
        )}
      </DialogTrigger>
      <DialogContent dir="rtl">
        <DialogHeader>
          <DialogTitle style={{ fontFamily: "IBM Plex Sans Arabic" }}>تغيير كلمة المرور</DialogTitle>
          <DialogDescription>أدخل كلمة المرور الحالية ثم الجديدة (8 أحرف على الأقل).</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label className="mb-1.5 block">كلمة المرور الحالية</Label>
            <Input type="password" value={form.current_password} onChange={(e) => setForm({ ...form, current_password: e.target.value })} required className="rounded-xl bg-white border-[#e6e2d8]" data-testid="current-password-input" />
          </div>
          <div>
            <Label className="mb-1.5 block">كلمة المرور الجديدة</Label>
            <Input type="password" value={form.new_password} onChange={(e) => setForm({ ...form, new_password: e.target.value })} required minLength={8} className="rounded-xl bg-white border-[#e6e2d8]" data-testid="new-password-input" />
          </div>
          <div>
            <Label className="mb-1.5 block">تأكيد كلمة المرور</Label>
            <Input type="password" value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} required minLength={8} className="rounded-xl bg-white border-[#e6e2d8]" data-testid="confirm-password-input" />
          </div>
          <DialogFooter className="gap-2">
            <Button type="button" variant="outline" onClick={() => setOpen(false)} className="rounded-xl">إلغاء</Button>
            <Button type="submit" disabled={saving} className="rounded-xl bg-[#3E6A56] hover:bg-[#2D4F40]" data-testid="save-password-button">
              {saving ? "جاري الحفظ..." : "حفظ"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
